import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'translate'
})
export class TranslatePipe implements PipeTransform {
  translationMap: any = {};
  lang: string;
  translations: any;
  constructor() {
    this.translations = localStorage.getItem('translations');
    this.lang = localStorage.getItem('lang') || 'ge';
    if (this.translations) {
      this.translations = JSON.parse(this.translations);
      this.translations.forEach(t => {
        this.translationMap[t.keyword] = t.translations;
      })
    }
  }
  transform(value: string): string {
    if (this.translationMap[value])
      return this.translationMap[value][this.lang]
    else return value;
  }

}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/pipes/translations.pipe.ts